var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import { connect } from "@irati/store";
import perkboxLogo from "@irati/ui/images/logo-alt.svg";
import StatusType from "@irati/wallet/types/enums/Status";
import authentication from "@irati/auth";
import PrimaryDetails from "../../../PrimaryDetails";
import { StyledCard } from "../../styled";
var ManualRefund = /** @class */ (function (_super) {
    __extends(ManualRefund, _super);
    function ManualRefund() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManualRefund.prototype.render = function () {
        var _a = this.props, statementItem = _a.statementItem, formatMessage = _a.formatMessage, wallet = _a.wallet;
        var transfer = statementItem.transfer;
        var amount = transfer.amount;
        var currency = wallet.currency || authentication.defaultUserCurrency();
        var primaryDetails = {
            image: perkboxLogo,
            title: formatMessage({ id: "wallet.statementItem.manualRefund.primaryDetails.title" }),
            subTitle: formatMessage({ id: "wallet.statementItem.manualRefund.primaryDetails.subTitle" }),
            amount: amount,
            currency: currency,
            status: StatusType.SPENT
        };
        var idNamespace = id("manual-refund-statement-item", this.props);
        return (React.createElement(StyledCard, { tiny: true, noBorder: true },
            React.createElement(PrimaryDetails, { imgHeightAuto: true, id: idNamespace, data: primaryDetails })));
    };
    return ManualRefund;
}(PureComponent));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({
        wallet: wallet
    });
};
export default injectIntl(connect(mapStateToProps)(ManualRefund));
